// 정산 및 종료 카드 (성과측정과 동일 UI, 폰트 기존 유지)
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import CreatorInfo from "./CreatorInfo";

function AccordionContent({
  item,
  isExpanded,
  waitingCount,
  completedCount,
  creatorCount,
}) {
  const [renderChildren, setRenderChildren] = useState(false);

  useEffect(() => {
    if (isExpanded) {
      const t = setTimeout(() => setRenderChildren(true), 180);
      return () => clearTimeout(t);
    } else {
      setRenderChildren(false);
    }
  }, [isExpanded]);

  return (
    <>
      <AccordionButton
                py="14px"
                px="18px"
                _hover={{ bg: "gray.50" }}
                _expanded={{ bg: "#F5F9FF" }}
                justifyContent="space-between"
                transition="background 0.2s"
              >
                <Flex
                  align="center"
                  flexDir="row"
                  gap="16px"
                  justify="space-between"
                  w="100%"
                >
                  <Flex flexDir="column" align="flex-start" gap="2px" flex="1" minW="0">
                    <Text
                      fontSize="20px"
                      fontWeight="700"
                      color="#172940"
                      noOfLines={1}
                    >
                      {item?.campaign?.title}
                    </Text>
                    {!isExpanded && (creatorCount > 0 || completedCount > 0) && (
                      <Text fontSize="14px" color="#5D6979" fontWeight={500}>
                        {completedCount > 0
                          ? `완료 ${completedCount}건${creatorCount > 0 ? ` · 크리에이터 ${creatorCount}명` : ""}`
                          : creatorCount > 0
                            ? `크리에이터 ${creatorCount}명`
                            : ""}
                      </Text>
                    )}
                  </Flex>
                  {!isExpanded && (
                    <Flex align="center" gap="14px" flexShrink={0}>
                      <Flex
                        align="center"
                        gap="8px"
                        px="14px"
                        py="8px"
                        bg="white"
                        borderRadius="8px"
                        border="1px solid"
                        borderColor="gray.200"
                      >
                        <Text fontSize="13px" color="#5D6979">
                          {item?.campaign?.billingModel === "CPUC"
                            ? "총 클릭 수"
                            : "총 노출 수"}
                        </Text>
                        <Text fontSize="15px" fontWeight={600} color="#172940">
                          {item?.campaign?.billingModel === "CPUC"
                            ? item?.summary?.totalActualInteractions ?? "-"
                            : item?.summary?.totalActualReach ?? "-"}
                          회
                        </Text>
                      </Flex>
                      <Flex
                        align="center"
                        gap="8px"
                        px="14px"
                        py="8px"
                        bg="white"
                        borderRadius="8px"
                        border="1px solid"
                        borderColor="gray.200"
                      >
                        <Text fontSize="13px" color="#5D6979">
                          목표 달성률
                        </Text>
                        <Text fontSize="15px" fontWeight={600} color="#0054C0">
                          {(
                            (item?.summary?.goalAchievementRate ?? 0) * 100
                          ).toFixed(1)}
                          %
                        </Text>
                      </Flex>
                      <Flex
                        align="center"
                        gap="8px"
                        px="14px"
                        py="8px"
                        bg="white"
                        borderRadius="8px"
                        border="1px solid"
                        borderColor="gray.200"
                      >
                        <Text fontSize="13px" color="#5D6979">
                          차감 예정 예치금
                        </Text>
                        <Text fontSize="15px" fontWeight={600} color="#172940">
                          {item?.summary?.totalGrossAmount != null
                            ? `${Number(item.summary.totalGrossAmount).toLocaleString()}원`
                            : "-"}
                        </Text>
                      </Flex>
                    </Flex>
                  )}
                  <AccordionIcon
                    fontSize="24px"
                    color="#0054C0"
                    flexShrink={0}
                  />
                </Flex>
              </AccordionButton>

              <AccordionPanel bg="#FAFCFF" px="18px" pt="14px" pb="18px">
                <SimpleGrid
                  columns={{ base: 2, md: 4 }}
                  spacing="10px"
                  w="100%"
                  mb="20px"
                >
                  <Box
                    w="100%"
                    p="16px"
                    bg="white"
                    borderRadius="12px"
                    border="1px solid"
                    borderColor="gray.200"
                  >
                    <Text fontSize="16px" fontWeight={700}>
                      광고 완료 현황
                    </Text>
                    <Flex align="center" gap="4px">
                      <Text fontSize="30px" color="#0054C0" fontWeight={700}>
                        {waitingCount}{" "}
                      </Text>
                      <Text pt="5px" fontSize="18px" color="#0054C0">
                        /{completedCount}
                      </Text>
                    </Flex>
                  </Box>

                  <Box
                    w="100%"
                    p="16px"
                    bg="white"
                    borderRadius="12px"
                    border="1px solid"
                    borderColor="gray.200"
                  >
                    <Text fontSize="16px" fontWeight={700}>
                      {item?.campaign?.billingModel === "CPUC"
                        ? "총 클릭 수"
                        : "총 노출 수"}
                    </Text>
                    <Flex align="center" gap="4px">
                      <Text fontSize="30px" color="#0054C0" fontWeight={700}>
                        {item?.campaign?.billingModel === "CPUC"
                          ? item?.summary?.totalActualInteractions
                          : item?.summary?.totalActualReach}
                      </Text>
                      <Text pt="5px" fontSize="18px" color="#0054C0">
                        회
                      </Text>
                    </Flex>
                  </Box>

                  <Box
                    w="100%"
                    p="16px"
                    bg="white"
                    borderRadius="12px"
                    border="1px solid"
                    borderColor="gray.200"
                  >
                    <Text fontSize="16px" fontWeight={700}>
                      전체 목표 달성률
                    </Text>
                    <Flex align="center" gap="4px">
                      <Text fontSize="30px" color="#0054C0" fontWeight={700}>
                        {(
                          (item?.summary?.goalAchievementRate ?? 0) * 100
                        ).toFixed(2)}
                      </Text>
                      <Text pt="5px" fontSize="18px" color="#0054C0">
                        %
                      </Text>
                    </Flex>
                  </Box>

                  <Box
                    w="100%"
                    p="16px"
                    bg="white"
                    borderRadius="12px"
                    border="1px solid"
                    borderColor="gray.200"
                  >
                    <Text fontSize="16px" fontWeight={700}>
                      차감 예정 예치금
                    </Text>
                    <Flex align="center" gap="4px">
                      <Text fontSize="30px" color="#0054C0" fontWeight={700}>
                        {item?.summary?.totalGrossAmount?.toLocaleString() ??
                          "-"}
                      </Text>
                      <Text pt="5px" fontSize="18px" color="#0054C0">
                        KRW
                      </Text>
                    </Flex>
                  </Box>
                </SimpleGrid>

                {renderChildren && (
                  <SimpleGrid
                    columns={{ base: 1, md: 2, lg: 3, "2xl": 4 }}
                    spacing="20px"
                  >
                    {item?.creators?.map((creator) => (
                      <CreatorInfo
                        key={creator.creatorProfileId ?? creator.id}
                        data={creator}
                        campaign={{ item }}
                      />
                    ))}
                  </SimpleGrid>
                )}
              </AccordionPanel>
            </>
  );
}

export default function WaitList({ item, defaultExpanded = false }) {
  const summary = item?.summary;
  const waitingCount = summary?.waitingCount ?? 0;
  const completedCount = summary?.completedCount ?? 0;
  const creatorCount = item?.creators?.length ?? 0;

  return (
    <Accordion allowMultiple w="100%" defaultIndex={defaultExpanded ? [0] : []}>
      <AccordionItem
        border="1px solid"
        borderColor="rgba(0, 84, 192, 0.14)"
        bg="white"
        borderRadius="12px"
        mb="8px"
        boxShadow="0 1px 3px rgba(23, 41, 64, 0.08)"
        overflow="hidden"
        _expanded={{
          boxShadow: "0 4px 16px rgba(23, 41, 64, 0.12)",
          borderColor: "rgba(0, 84, 192, 0.2)",
        }}
      >
        {({ isExpanded }) => (
          <AccordionContent
            item={item}
            isExpanded={isExpanded}
            waitingCount={waitingCount}
            completedCount={completedCount}
            creatorCount={creatorCount}
          />
        )}
      </AccordionItem>
    </Accordion>
  );
}
